import { render, staticRenderFns } from "./CardFieldset.vue?vue&type=template&id=0883460c&scoped=true&"
import script from "./CardFieldset.vue?vue&type=script&lang=js&"
export * from "./CardFieldset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0883460c",
  null
  
)

export default component.exports